export class NotAuthenticatedError extends Error {

    constructor() {
        super("Failed to refresh token");
        Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
    }
}
